export const BUSINESS_REGISTRATION = 'business_registration';
export const PHONE_ENTER = 'phone-enter';
export const LOG_IN_SMSCODE = 'log-in-smscode';
export const TRANSACTION_SUCCESSFUL = 'transaction_successful';
export const SEND_FIRST_SUCCESS = 'send_first_success';

// The REGISTRATION_SUCCESS and the REGISTRATION_SUCCESSFULLY_COMPLETED identify the same event.
// We are guessing and trying to fix statistics collection issue, that's why.
export const REGISTRATION_SUCCESS = 'registration-success';
export const REGISTRATION_SUCCESSFULLY_COMPLETED = 'registration-successfully-completed';

// GOOGLE TAG MANAGER EVENTS
export const GT_REG_PHONE_DONE = 'reg-phone-done';
export const GT_REG_SUCCESS = 'reg-success';
export const GT_LOGIN_SUCCESS = 'login-success';
export const GT_SEND_MONEY_FROM_AMOUNT = 'send-money-from-amount';
export const GT_NEW_TRANSFER_START = 'new-transfer-start';
export const GT_TRANSFER_REPEAT_START = 'transfer-repeat-start';
export const GT_OUT_REQUEST_SEND = 'out-request-send';
export const GT_SEND_SUCCESS = 'send-success';

// GA4 EVENTS
// Note: The GA4 events are preferrably used.
//   * GA4_SIGN_UP has same meaning as REGISTRATION_SUCCESSFULLY_COMPLETED.
//   * GA4_SEND_FIRST_SUCCESS is equal to SEND_FIRST_SUCCESS, but it is used in GA4.
export const GA4_SIGN_UP = 'sign_up';
export const GA4_SEND_FIRST_SUCCESS = 'send_first_success';

// Libre
export const GT_LIBRE_LANDING_PAGE_SHOWN = 'Libre Landing Page Shown';
export const GT_LP_RECEIVE_MONEY_CLICKED = 'LP Receive Money Clicked';
export const GT_LP_FAQ_CLICKED = 'LP FAQ Clicked';
